/**
 * @license Copyright (c) 2014-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

import { ClassicEditor } from '../node_modules/@ckeditor/ckeditor5-editor-classic';

import { Alignment } from '../node_modules/@ckeditor/ckeditor5-alignment';
import { Autoformat } from '../node_modules/@ckeditor/ckeditor5-autoformat';
import { Bold, Italic } from '../node_modules/@ckeditor/ckeditor5-basic-styles';
import { BlockQuote } from '../node_modules/@ckeditor/ckeditor5-block-quote';
import { Essentials } from '../node_modules/@ckeditor/ckeditor5-essentials';
import { FontBackgroundColor, FontColor, FontFamily, FontSize } from '../node_modules/@ckeditor/ckeditor5-font';
import { Heading } from '../node_modules/@ckeditor/ckeditor5-heading';
import { Highlight } from '../node_modules/@ckeditor/ckeditor5-highlight';
import { HorizontalLine } from '../node_modules/@ckeditor/ckeditor5-horizontal-line';
import { HtmlEmbed } from '../node_modules/@ckeditor/ckeditor5-html-embed';
import { GeneralHtmlSupport, HtmlComment } from '../node_modules/@ckeditor/ckeditor5-html-support';
import { FullPage } from '../node_modules/@ckeditor/ckeditor5-html-support';
import {
	Image,
	/*ImageCaption,*/
	ImageResize
	/*ImageStyle,
	ImageToolbar,
	ImageUpload*/
} from '../node_modules/@ckeditor/ckeditor5-image';
import { Indent } from '../node_modules/@ckeditor/ckeditor5-indent';
import { Link, LinkImage, LinkImageEditing, LinkImageUI} from '../node_modules/@ckeditor/ckeditor5-link';
import { List } from '../node_modules/@ckeditor/ckeditor5-list';
import { MediaEmbed } from '../node_modules/@ckeditor/ckeditor5-media-embed';
import { Paragraph } from '../node_modules/@ckeditor/ckeditor5-paragraph';
import { PasteFromOffice } from '../node_modules/@ckeditor/ckeditor5-paste-from-office';
import { RemoveFormat, RemoveFormatEditing, RemoveFormatCommand, RemoveFormatUI } from '../node_modules/@ckeditor/ckeditor5-remove-format';
import { SourceEditing } from '../node_modules/@ckeditor/ckeditor5-source-editing';
import { Style } from '../node_modules/@ckeditor/ckeditor5-style';
import {
	Table,
	TableCaption,
	TableCellProperties,
	TableColumnResize,
	TableProperties,
	TableToolbar
} from '../node_modules/@ckeditor/ckeditor5-table';
import { TextTransformation } from '../node_modules/@ckeditor/ckeditor5-typing';

// You can read more about extending the build with additional plugins in the "Installing plugins" guide.
// See https://ckeditor.com/docs/ckeditor5/latest/installation/plugins/installing-plugins.html for details.

class Editor extends ClassicEditor {
	public static override builtinPlugins = [
		Alignment,
		Autoformat,
		BlockQuote,
		Bold,
		Essentials,
		FontBackgroundColor,
		FontColor,
		FontFamily,
		FontSize,
		GeneralHtmlSupport,
		FullPage,
		Heading,
		Highlight,
		HorizontalLine,
		HtmlComment,
		HtmlEmbed,
		Image,
		/*ImageCaption,*/
		ImageResize,
		/*ImageStyle,*/
		/*ImageToolbar,*/
		/*ImageUpload,*/
		Indent,
		Italic,
		Link,
		LinkImage,
		List,
		MediaEmbed,
		Paragraph,
		PasteFromOffice,
		RemoveFormat, RemoveFormatEditing, RemoveFormatUI,
		SourceEditing,
		Style,
		Table,
		TableCaption,
		TableCellProperties,
		TableColumnResize,
		TableProperties,
		TableToolbar,
		TextTransformation
	];

	public static override defaultConfig = {
		toolbar: {
			items: [
				'sourceEditing',
				'bold',
				'italic',
				'link',
				'removeFormat',
				'bulletedList',
				'numberedList',
				'|',
				'outdent',
				'indent',
				'|',
				'blockQuote',
				'insertTable',
				'mediaEmbed',
				'undo',
				'redo',
				'fontBackgroundColor',
				'fontColor',
				'fontFamily',
				'fontSize',
				'alignment',
				'highlight',
				'horizontalLine',
				'htmlEmbed'
			]
		},
		language: 'fr',
		image: {
			toolbar: [
				'imageTextAlternative',
				'toggleImageCaption',
				'imageStyle:inline',
				'imageStyle:block',
				'imageStyle:side',
				'linkImage'
			]
		},
		table: {
			contentToolbar: [
				'tableColumn',
				'tableRow',
				'mergeTableCells',
				'tableCellProperties',
				'tableProperties'
			]
		}
	};
}

export default Editor;
